var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6605_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 40L12.1583 29.0917L1.25 25L12.1583 20.9083L16.25 10L20.3417 20.9083L31.25 25L20.3417 29.0917L16.25 40Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 13.75L5.03333 8.71667L0 6.875L5.03333 5.03333L6.875 0L8.71667 5.03333L13.75 6.875L8.71667 8.71667L6.875 13.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 20L28.82 13.68L22.5 11.25L28.82 8.82L31.25 2.5L33.68 8.82L40 11.25L33.68 13.68L31.25 20Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6605_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AIIcon.2bcdd22a0ae402b6577562b1ef450182.svg";
export { ForwardRef as ReactComponent };